import PropTypes from 'prop-types';
import React from 'react';

import linkPropType from '@/custom-prop-types/link';
import { CardComplexContent } from '@/design-system/atoms/Cards/CardComplexContent';
import { Carousel } from '@/design-system/atoms/Carousel';
import { ContentContainer } from '@/design-system/atoms/ContentContainer';
import { Theme } from '@/design-system/atoms/Theme';
import { Title } from '@/design-system/atoms/Title';

import styles from './ComplexCardCarousel.module.scss';

const ComplexCardCarousel = (props) => {
    const { title, cta, carouselItems, theme } = props;
    const carouselCards = React.useMemo(() => {
        const carouselCards = carouselItems?.map((item, index) => (
            <Carousel.Card>
                <CardComplexContent
                    {...item}
                    key={index}
                    analyticsActionLabel={item.title}
                    analyticsComponentTitle={props.analyticsActionLabel}
                />
            </Carousel.Card>
        ));
        return carouselCards;
    }, [carouselItems, props.analyticsActionLabel]);

    return (
        <Theme name={theme} className={styles.wrapper}>
            {title && (
                <ContentContainer>
                    <Title
                        tag={Title.TAG.H2}
                        variant={Title.TAG.H3}
                        content={title}
                        className={styles.title}
                        lineClamp={{ sm: 3, lg: 1 }}
                    />
                </ContentContainer>
            )}

            <Carousel.Root>
                <Carousel.Content items={carouselCards} />
                <Carousel.Footer>
                    {cta && (cta.href || cta.label) && (
                        <Carousel.CallToAction
                            {...cta}
                            analytics={{
                                componentName: props.analyticsComponentTitle,
                                componentTitle: title,
                            }}
                        />
                    )}

                    <Carousel.Spacer />
                    <Carousel.Navigation
                        analytics={{
                            componentName: props.analyticsComponentTitle,
                            componentTitle: title,
                        }}
                    />
                </Carousel.Footer>
            </Carousel.Root>
        </Theme>
    );
};

ComplexCardCarousel.propTypes = {
    title: PropTypes.string,
    cta: linkPropType,
    carouselItems: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            subtitle: PropTypes.string,
            featuredIcon: PropTypes.string,
            featuredContent: PropTypes.string,
            body: PropTypes.string,
            cta: linkPropType,
        }),
    ),
    theme: PropTypes.oneOf(['light', 'medium']),
    analyticsComponentTitle: PropTypes.string,
};

export default ComplexCardCarousel;
